let settings = null;

const hostname = window.location.hostname;
const environment = () => {

    if (hostname.includes('localhost')) return "local";
    if (hostname.includes('iat.affinityplatform')) return "iat";
    return "prod";
  //if (/localhost/i.test(hostname)) return "local";
  //if (/iat.affinityplatform[.|-]/i.test(hostname)) return "iat";
  //return "prod";
};

const load = async () => {
  const env = environment();
  let loaded = await import(`./settings/${env}`);
  settings = {
    ...loaded,
    env,
  };
};

export { settings as default, load };
